/**
 * Scroll Performance Utilities
 */

/**
 * Request Animation Frame throttle - best for visual updates
 * Syncs with browser's repaint cycle (60fps)
 */
export function rafThrottle<T extends (...args: any[]) => void>(
  func: T
): (...args: Parameters<T>) => void {
  let rafId: number | null = null;
  return function(this: any, ...args: Parameters<T>) {
    if (rafId === null) {
      rafId = requestAnimationFrame(() => {
        func.apply(this, args);
        rafId = null;
      });
    }
  };
}
